import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { retry } from './utils';
import ScrollToTop from './ScrollToTop';
import GetNewUID from './Pages/GetNewUID';

// Add retry to lazy components in case of loading/chunk failures -
// Reference - https://goenning.net/2018/11/16/how-to-retry-dynamic-import-with-react-lazy/

const NewQuestions = lazy(() => retry(() => import('./Pages/Questions/NewQuestions')));
const QuoteDataCollectionPage = lazy(() => retry(() => import('./Pages/QuoteDataCollectionPage')));
const PageNotFound = lazy(() => retry(() => import('./Pages/PageNotFound')));
const SignError = lazy(() => retry(() => import('./Pages/SignError')));
const PDFDownloadLink = lazy(() => retry(() => import('./Pages/PDFDownloadLink')));
const SSORedirection = lazy(() => retry(() => import('./Pages/SSORedirection')));

const AppRouter = () => {
  return (
    <>
      <ScrollToTop>
        <Suspense fallback={ <GetNewUID /> }>
          <Switch>
            <Route
              path={ [
                '/quote',
                '/plan',
                '/questions/:id',
                '/review',
                '/payment',
                '/signature',
                '/challenge',
                '/timeout',
                '/completed',
                '/knockout',
                '/inactivesession',
              ] }
              component={ NewQuestions }
            />
            <Route path={ ['/login'] } component={ QuoteDataCollectionPage } />
            <Route path={ ['/view-document'] } component={ PDFDownloadLink } />
            <Route
              exact
              path={ ['/ssodone', '/ssodone/', '/authError', '/authError/'] }
              component={ SSORedirection }
            />
            <Route exact path={ ['/', '/init', '/e-signature'] } component={ GetNewUID } />
            <Route exact path={ ['/signError', '/signError/'] } component={ SignError } />
            <Route exact path='*' component={ PageNotFound } />
          </Switch>
        </Suspense>
      </ScrollToTop>
    </>
  );
};

export default AppRouter;
